// components/layout/services-panel-mobile.jsx
'use client';

import Link from 'next/link';
import { ChevronDown } from 'lucide-react';
import { DynamicIcon } from 'lucide-react/dynamic';

export default function MobileServicesPanel({
    isLight,
    categories,
    activeCategory,
    setActiveCategory,
    onLinkClick,
    promo,
    closeDropdown,
}) {
    const safeHref = (href) => (href?.startsWith('/') ? href : `/${href}`);

    return (
        <div className="flex flex-col space-y-3">
            {categories.map((cat, i) => {
                const open = activeCategory === i;
                return (
                    <div
                        key={cat.title}
                        className={`border-b pb-3 ${isLight ? 'border-slate-200' : 'border-slate-800'}`}
                    >
                        <button
                            type="button"
                            onClick={() => setActiveCategory(open ? -1 : i)}
                            className="flex justify-between items-center w-full text-left"
                        >
                            <div className="flex items-center gap-3">
                                <DynamicIcon
                                    name={cat.icon}
                                    className={`w-5 h-5 ${isLight ? 'text-primary' : 'text-blue-300'}`}
                                />
                                <span className="font-semibold">{cat.title}</span>
                            </div>
                            <ChevronDown
                                className={`w-4 h-4 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
                            />
                        </button>

                        <div
                            className={`${open ? 'mt-2 opacity-100' : 'max-h-0 opacity-0 pointer-events-none'} transition-all duration-300`}
                        >
                            <ul className="space-y-2 pl-0">
                                {cat.links.map(([text, slug]) => (
                                    <li key={slug}>
                                        <Link
                                            href={safeHref(slug)}
                                            onClick={() => {
                                                closeDropdown();
                                                onLinkClick?.();
                                            }}
                                            className={`text-sm ${isLight ? 'text-slate-600 hover:text-primary' : 'text-slate-300 hover:text-blue-300'} transition-colors`}
                                        >
                                            {text}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                );
            })}

            {/* Mobile bottom CTA (simple, no third column) */}
            <div className="pt-2 flex flex-col gap-2">
                <Link
                    href={safeHref(promo?.ctaHref || '/contact-us')}
                    onClick={() => closeDropdown()}
                    className={`inline-flex items-center justify-center rounded-xl px-3 py-2 text-sm font-semibold transition ${
                        isLight
                            ? 'bg-primary text-white hover:opacity-90'
                            : 'bg-blue-500 text-white hover:bg-blue-400'
                    }`}
                >
                    {promo?.ctaLabel || 'Book a call'}
                </Link>

                <Link
                    href={safeHref(promo?.secondaryHref || '/services')}
                    onClick={() => closeDropdown()}
                    className={`text-center text-sm font-semibold ${
                        isLight
                            ? 'text-slate-800 hover:text-primary'
                            : 'text-slate-100 hover:text-blue-300'
                    }`}
                >
                    {promo?.secondaryLabel || 'View all services'}
                </Link>
            </div>
        </div>
    );
}
